import React, { Component } from "react"
import PropTypes from "prop-types"

import {
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
} from "shared/search/containers/Filter/Filters"

import { enumGenericFilter, searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    ActionCenterSettingsSearchifyFLV,
    IssueManagementFilterableListView,
    UserFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    ActionCenterSettingsSelect,
    IssueManagementSelect,
    UserSelect,
} from "app/static/frontend/selects/containers/PieSelect"
import { CampaignTypeSelect } from "app/static/frontend/selects/containers/EnumSelect"

export class CampaignTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "CampaignTypeFilter",
        filterKey: "campaign_type__in",
        enumItems: DjangIO.app.grassroots.campaign.types.CampaignType.region_supported_items().filter(
            (item) => item.is_enabled_for_campaign_form,
        ),
        sortBy: enumValueSort,
        selectComponent: CampaignTypeSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignActionCenterFilter extends Component {
    static defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "campaignActionCenterFilter",
        filterKey: "for_action_centers",
        searchifyFLV: ActionCenterSettingsSearchifyFLV,
        dataTypeLabel: "Action Centers",
        displayLabel: "Action Centers",
        selectComponent: ActionCenterSettingsSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "CampaignStatusFilter",
        filterKey: "status__in",
        enumItems: DjangIO.app.grassroots.campaign.types.CampaignStatus.region_supported_items().filter(
            (item) => !item.key.includes("draft"),
        ),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignStartDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "CampaignStartDateAfterFilter",
        filterKey: "activated__gt",
        displayLabel: "Start Date After",
        helpText: "Campaigns started after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignStartDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "CampaignStartDateBeforeFilter",
        filterKey: "activated__lt",
        displayLabel: "Start Date Before",
        helpText: "Campaigns started before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignEndDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "CampaignEndDateAfterFilter",
        filterKey: "completed__gt",
        displayLabel: "End Date After",
        helpText: "Campaigns ended after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignEndDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "CampaignEndDateBeforeFilter",
        filterKey: "completed__lt",
        displayLabel: "End Date Before",
        helpText: "Campaign ended before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CampaignProjectFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "CampaignProjectFilter",
            filterKey: "for_project_and_subprojects",
            searchifyFLV: IssueManagementFilterableListView,
            dataTypeLabel: "Projects",
            selectComponent: IssueManagementSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const CampaignInvolvingUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
CampaignInvolvingUserFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
CampaignInvolvingUserFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "campaignInvolvingUser",
    filterKey: "involving_user",
    dataTypeLabel: "Users",
    selectComponent: UserSelect,
}
